<template>
  <div class="editor">
      <div id="fwb" >
      </div>
    </div>
</template>

<script>
  import weditor from 'wangEditor';
  export default {
    name: 'editor',
    data() {
      return {
        editor: {}
      }
    },
    methods: {
      editorInit() {
        this.editor = new weditor('#fwb')
        this.editor.config.height = 500
        this.editor.config.uploadImgServer = '/api/system/uploadImg'
        this.editor.config.uploadImgHeaders = {
            token: localStorage.getItem('logintoken')
        }
        this.editor.config.uploadImgAccept = ['jpg', 'jpeg', 'png', 'gif']
        this.editor.config.uploadImgMaxSize = 2 * 1024 * 1024
        this.editor.config.uploadFileName = 'file'
        this.editor.config.uploadImgHooks = {
          customInsert: function(insertImgFn, result) {
              insertImgFn(result.data)
          }
        }
        this.editor.create()
      },
      setcontent() {
        this.$emit('callFather', this.editor.txt.html())
      },
      editcontent(content) {
        this.editor.txt.html(content)
      }
    },
    mounted() {
      this.editorInit();
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/wangEditor.vue